import type { MarketingPageContent } from './types';

export const FOR_FILMMAKERS_CONTENT: MarketingPageContent = {
  title: 'Induce for Filmmakers',
  headerLabel: 'For Filmmakers',
  lede:
    'Upload a screenplay. Get a cinematic cut. Induce reads your script and generates every shot with continuity, composition, and directorial intent. For filmmakers, enterprises, agencies and indie creators.',
  sections: [
    {
      id: 'script-first',
      title: 'Script-first workflow',
      body: '80% less prompting than other platforms. Upload your script, skip the prompt engineering. Induce handles the translation from story to screen.',
    },
    {
      id: 'ingest',
      title: 'Upload your script',
      body: 'FDX, PDF, Fountain, or paste directly. Induce handles formatting, slug lines, dual-dialogue, and every production annotation.',
    },
    {
      id: 'shot-control',
      title: 'Director-grade shot control',
      body: 'Override any shot, angle, lighting, pacing, performance - without disturbing the surrounding cut. Overrides read as notes to the system, not full re-prompts.',
    },
  ],
};
